import { EMAIL, USER_ID } from '../helpers/constants';
import { AllSameKeyValuesEnforcer, JustTime } from '../helpers/helpers'
import { User } from './user.data';

export const OMEGA_GROUP_NAME = 'Program & Logistics Teams'
export const OMEGA_GROUP_ID = '--all--';

interface TaskTabs { info, messages, logs, }
export const taskTabs: AllSameKeyValuesEnforcer<TaskTabs> = { info: 'info', messages: 'messages', logs: 'logs' }

export interface TimeLogSummary {
  estimatedTime?: JustTime,
  loggedTime?: JustTime,
  difference?: JustTime,
  percentDone?: number,
  hasEstimatedTime?: boolean
}

export type TaskStatus = 'open' | 'inProgress' | 'reviewing' | 'onHold' | 'complete'
export const taskStatusNames: { [t in TaskStatus]: string } = { open: 'Open', inProgress: 'In Progress', reviewing: 'Review', onHold: 'On Hold', complete: 'Complete' }
export const taskStatusOrders: { [t in TaskStatus]: number } = { open: 0, inProgress: 1, reviewing: 2, onHold: 3, complete: 4 }

export interface Task {
  comments?: Array<JoiComment>;
  log?: Array<LogEntry>
  estimatedTime?: JustTime
  completed?: boolean;
  completedBy?: EMAIL;
  completedAt?: Date;
  content?: string;
  createdBy: USER_ID;
  createdAt?: Date | any;
  updatedAt?: Date | any;
  date?: Date | any;
  dueDate?: any
  isOverDue: boolean;
  files?: Array<any>;
  flag?: boolean; // { [uid: string]: boolean }; was this before June 8 2021
  id?: string;
  labels?: string[];
  condensedLabels?: string[];
  name: string;
  program?: string;
  responsibility?: EMAIL;
  visibility?: EMAIL[]
  groupVisibility?: string[]
  eventId: string;
  accountId?: string
  reminderTime: any;
  seen: any;
  showHeader?: boolean;
  commentBookmarks: { [uid: string]: number };
  subtasks?: Array<string>
  subtasks_obj:  {[key:string]: Subtask};
  subtasksCompleted?: number;
  subtaskSeed?: number;
  entityId?: string
  status?: TaskStatus
}

export const DBTaskPropertyWhiteList: Array<keyof Task> = [
  'status',
  'comments',
  'entityId',
  'log',
  'estimatedTime',
  'completed',
  'completedAt',
  'completedBy',
  'content',
  'createdBy',
  'createdAt',
  'dueDate',
  'files',
  'flag',
  'id',
  'labels',
  'name',
  'program',
  'responsibility',
  'visibility',
  'groupVisibility',
  'eventId',
  'reminderTime',
  'seen',
  'commentBookmarks',
  'subtasks',
  'subtasks_obj',
  'subtasksCompleted',
  'subtaskSeed'
]

export interface Subtask {
  completed?: boolean;
  completedBy?: string;
  completedAt?: Date;
  createdAt?: any;
  id?: string;
  name: string;
}

export interface JoiComment {
  content: string;
  createdBy: string;
  createdAt: Date;
  edited?: boolean
  dateModified?: number
  id?: string // implemented from quickNotes on
}

export interface LogEntry extends JoiComment {
  id: string
  loggedTime: JustTime
}

export interface TaskTriggers {
  task_status_has_changed: boolean,
  should_update_remindTime: boolean,
  was_responsible_on_delete?: string,
  inform_creator_on_delete?: string,
  will_be_responsible?: string,
  wont_be_responsible?: string
}


export const filterTimeTasks = (tasks: Task[], user: User): Task[] => tasks.filter(t => ![
  !!t.groupVisibility && t.groupVisibility.includes(OMEGA_GROUP_ID) || (t.responsibility && t.responsibility === user.email) || t.visibility.includes(user.email),
  t.estimatedTime || (t.log && t.log.length)
].some(f => !f))